'use client';

import { Tab, TabProps } from '@virginmediao2/momentum-nextjs/tabs';
import { FC, useCallback } from 'react';

import { TABS_PERSIST_KEY } from './tabs-provider';
import { useTabsContext } from './tabs.context';

export interface TabProviderProps extends TabProps {
  id: string;
}

export const TabProvider: FC<TabProviderProps> = ({
  id,
  children,
  ...props
}) => {
  const { activeTabId, setActiveTabId } = useTabsContext();
  const syncParam = useSyncedParamCallback();

  const handleOnClick = useCallback(() => {
    syncParam(id);
    setActiveTabId(id);
  }, [id, syncParam, setActiveTabId]);

  return (
    <Tab
      {...props}
      active={activeTabId === id}
      aria-controls={id}
      onClick={handleOnClick}
    >
      {children}
    </Tab>
  );
};

const useSyncedParamCallback = () => {
  const { persist } = useTabsContext();
  return useCallback(
    (id: string) => {
      const params = new URLSearchParams(window.location.search);
      const param = params?.get(TABS_PERSIST_KEY);

      if (param) {
        persist
          ? params.set(TABS_PERSIST_KEY, id)
          : params.delete(TABS_PERSIST_KEY);

        window.history.pushState(null, '', `?${params.toString()}`);
      }
    },
    [persist]
  );
};
